import api from '@/client/core/api'

import { InstagramInstantwinEnqueteAnalyticsResponse } from '../types'

export type GetInstagramInstantwinEnqueteAnalyticsParams = {
  campaignId: number
  prizeId: number
  startDatetime: string
  endDatetime: string
  selectNodeId?: number | null
}

export type InstagramInstantwinEnqueteAnalyticsApiResponse = {
  data?: InstagramInstantwinEnqueteAnalyticsResponse
  error?: {
    type?: string
    message?: string
    status?: number
  }
}

export class InstagramInstantwinEnqueteAnalyticsApiError extends Error {
  constructor(
    public type: string,
    message?: string,
    public status?: number
  ) {
    super(message || type)
  }
}

export async function getInstagramInstantwinEnqueteAnalytics(
  params: GetInstagramInstantwinEnqueteAnalyticsParams
): Promise<InstagramInstantwinEnqueteAnalyticsResponse> {
  const requestParams: Record<string, unknown> = {
    prizeId: params.prizeId,
    startDatetime: params.startDatetime,
    endDatetime: params.endDatetime
  }

  if (params.selectNodeId) {
    requestParams.selectNodeId = params.selectNodeId
  }

  const response = await api.get<InstagramInstantwinEnqueteAnalyticsApiResponse>(
    `/instagram_instantwin_campaign_analytics/${params.campaignId}/questionnaire`,
    {
      params: requestParams
    }
  )

  if (response?.error?.type) {
    throw new InstagramInstantwinEnqueteAnalyticsApiError(
      response.error.type,
      response.error.message,
      response.error.status
    )
  }

  return (
    response.data ?? {
      questions: [],
      selectedQuestion: null,
      answers: [],
      totalCount: 0
    }
  )
}
